<template>
    <div>
        <div class="row">
            <div class="column small-9">
                <PageTitle title="Contract sjablonen" :total="total" :loading="loading" />
            </div>
            <div class="column small-3 text-right">
                <!-- <b-button type="is-dark" tag="router-link" :to="{ name: 'ContractsRecordView', params: {id: 'nieuw'} }">Contract aanmaken</b-button> -->
            </div>
        </div>

        <div class="row">
            <div class="column">
                <ContractsTemplatesTable
                    ref="ContractsTemplatesTable"
                    @passTotal="passTotal"
                    @passLoading="passLoading"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ContractsTemplatesTable from './ContractsTemplatesTable'
import filtersMixin from '@/mixins/filterMixins'

export default {
    name: 'ContractsTemplates',
    mixins: [filtersMixin],

    components: {
        ContractsTemplatesTable
    },

    data() {
        return {
            total: null,
            loading: false
        }
    },

    methods: {
        passTotal(total) {
            this.total = total
        },
        passLoading(loading) {
            this.loading = loading
        }
    },

    mounted() {
        // Check if in this session a query is saved (last success) else use default sorting.
        this.$refs['ContractsTemplatesTable'].getSearchParams().then(() => {
            this.$refs['ContractsTemplatesTable'].loadAsyncData()
        })
    }
}
</script>